import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: ${props => props.theme.colors.background};
`;

const ProductBox = styled(motion.div)`
  background: #f9f7f5;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(44, 62, 80, 0.08);
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const ProductImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 1rem;
`;

const ProductTitle = styled.h2`
  font-size: 1.2rem;
  color: #2C3E50;
  font-weight: 700;
  margin-bottom: 0.7rem;
`;

const Price = styled.div`
  font-size: 2rem;
  color: #4A6FA5;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

const PriceSub = styled.div`
  font-size: 1rem;
  color: #6C757D;
  margin-bottom: 1.2rem;
`;

const BonusStack = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(44, 62, 80, 0.06);
  padding: 1rem 0.5rem;
  margin-bottom: 1.2rem;
`;

const BonusTitle = styled.div`
  color: #28A745;
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
`;

const BonusList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BonusItem = styled.li`
  color: #2C3E50;
  font-size: 1rem;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  &:before {
    content: '🎁';
    font-size: 1.1rem;
  }
`;

const CTAButton = styled(motion.button)`
  background-color: #FF7A00;
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  margin-top: 1.2rem;
  width: 100%;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
  &:hover {
    background-color: #E8B4B8;
    color: #2C3E50;
  }
`;

const Guarantee = styled.div`
  color: #6C757D;
  font-size: 0.95rem;
  margin-top: 1.2rem;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 1.2rem 0;
`;
const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  color: #2C3E50;
  font-size: 1.05rem;
  margin-bottom: 0.5rem;
  &:before {
    content: '✔ ';
    color: #28A745;
    font-size: 1.2rem;
    font-weight: bold;
  }
`;

const NoCheckItem = styled.li`
  color: #2C3E50;
  font-size: 1.05rem;
  margin-bottom: 0.5rem;
  list-style: none;
  padding-left: 0;
`;

const GuaranteeBanner = styled.div`
  background: #F9F7F5;
  color: #28A745;
  font-weight: 700;
  font-size: 1.1rem;
  border-radius: 10px;
  padding: 0.7rem 1.5rem;
  margin: 2rem auto 1.5rem auto;
  text-align: center;
  border: 2px solid #28A745;
  box-shadow: none;
`;

const FAQSection = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 8px rgba(44,62,80,0.07);
  padding: 2rem 1.2rem;
  max-width: 600px;
  margin: 2rem auto 2rem auto;
`;
const FAQTitle = styled.h3`
  color: #4A6FA5;
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1.2rem;
`;
const AccordionItem = styled.div`
  border-bottom: 1px solid #E9ECEF;
`;
const AccordionHeader = styled.button`
  width: 100%;
  background: none;
  border: none;
  outline: none;
  text-align: left;
  padding: 1rem 0;
  font-size: 1.05rem;
  color: #2C3E50;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
const AccordionContent = styled.div`
  color: #6C757D;
  font-size: 0.98rem;
  line-height: 1.5;
  padding-bottom: 1rem;
`;

const carouselImages = [
  '/product-image.png',
  '/product-image2.png',
  '/product-image3.png',
  '/product-image4.png',
  '/product-image5.png',
  '/product-image6.png',
  '/product-image7.png',
  '/product-image8.png',
];

const faqs = [
  {
    q: 'Was ist Derma Renew Komplex?',
    a: 'Derma Renew Komplex ist ein Nahrungsergänzungsmittel in Kapselform, das speziell entwickelt wurde, um die Hautelastizität zu verbessern und das Erscheinungsbild von Falten zu reduzieren. Die Kombination aus den genannten Inhaltsstoffen kann einen kraftvollen Effekt bei der Reduzierung von Falten und feinen Linien erreichen.'
  },
  {
    q: 'Wie lauten die genauen Inhaltsstoffe vom Derma Renew Komplex?',
    a: 'Zutaten: Fisch Hydrolysiertes Kollagen Peptan® F, vegane Kapselhülle, Sägepalme 20:1, MSM (Methylsulfony/methan), Wilde Yamswurzel Extrakt, Natriumhyaluronat, Vitamin B7 (Biotin), Füllstoff: Mikrokristalline Cellulose, Schachtelhalm-Extrakt 25:1, Trennmittel: Magnesiumstearat, Vitamin B1 (Thiamin HCL), Vitamin B2 (Riboflavin), Vitamin B3 (Nicotinamid), Vitamin B6 (Pyridoxinhydrochlorid), Vitamin A (Retinylpalmitat), 6S-5-Methyltetrahydrofolat Calcium.'
  },
  {
    q: 'Wie funktioniert die 90 Tage Geld-Zurück-Garantie?',
    a: 'Wir setzen alles daran, Ihnen mit Derma Renew Complex ein hochwirksames und natürliches Anti-Aging Produkt zu bieten. Jede Kapsel wird nach höchsten Qualitätsstandards hergestellt. Wir sind so überzeugt von der Wirksamkeit unserer Formel, dass wir Ihnen eine 100% Zufriedenheitsgarantie geben: Sollten Sie nicht begeistert sein, erhalten Sie Ihr Geld vollständig zurück. Diese Garantie motiviert uns, die Formel stetig weiterzuentwickeln, um Ihnen beste Ergebnisse zu liefern. Testen Sie Derma Renew Complex völlig risikofrei.'
  },
  {
    q: 'Wie hilft das Produkt bei der Faltenreduzierung?',
    a: 'Das Produkt enthält Kollagen und Hyaluronsäure, die beide für ihre positiven Effekte auf die Haut bekannt sind. Kollagen unterstützt die Festigkeit und Elastizität der Haut, während Hyaluronsäure Feuchtigkeit spendet und die Haut hydratisiert, was zur Reduzierung von Falten führen kann. Zusätzlich hilft die enthaltene Sägepalme das altersbeschleunigende DHT Hormon zu bremsen.'
  },
  {
    q: 'Wie soll ich das Produkt einnehmen?',
    a: 'Die empfohlene Dosierung beträgt zwei Kapseln täglich. Es wird empfohlen, die Kapseln mit einem Glas Wasser einzunehmen, vorzugsweise zu den Mahlzeiten, um eine optimale Aufnahme zu gewährleisten.'
  },
  {
    q: 'Wie lange dauert es, bis ich Ergebnisse sehe?',
    a: 'Die Ergebnisse können von Person zu Person variieren. Einige Anwender berichten von Verbesserungen in der Hautstruktur bereits nach wenigen Wochen. Für optimale Ergebnisse wird jedoch eine kontinuierliche Einnahme über einen Zeitraum von mindestens 3 Monaten empfohlen.'
  },
  {
    q: 'Ist das Produkt für Vegetarier geeignet?',
    a: 'Beim im Derma Renew Komplex enthaltenen Kollagen handelt es sich um Kollagen aus Fischbestand. Daher ist es nicht für Vegetarier geeignet.'
  }
];

const OfferHeadline = styled.div`
  font-family: ${props => props.theme.typography.fontFamily.primary};
  font-size: 1.54rem;
  color: #4A6FA5;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
`;

const OfferScreen = () => {
  const [mainImage, setMainImage] = useState(carouselImages[0]);
  const [openIdx, setOpenIdx] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setMainImage(prev => {
        const idx = carouselImages.indexOf(prev);
        return carouselImages[(idx + 1) % carouselImages.length];
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Container>
      <OfferHeadline>
        Alle wichtigen Inhaltsstoffe für vitale & strahlende Haut in einer Kapsel.
      </OfferHeadline>
      <FeatureList>
        <FeatureItem>Hochwertige Hautpflege von innen. Die All-in-One Lösung</FeatureItem>
        <FeatureItem>5 wissenschaftlich ausgewählte & optimal dosierte Wirkstoffe</FeatureItem>
        <FeatureItem>Mit Kollagenpeptiden, Sägepalmenextrakt, Hyaluronsäure, Vitaminen und wertvollen Pflanzenstoffen</FeatureItem>
      </FeatureList>
      <ProductBox
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div style={{ marginBottom: 16 }}>
          <img src={mainImage} alt="Produkt" style={{ width: 350, height: 350, objectFit: 'contain', borderRadius: 12, boxShadow: '0 2px 8px rgba(44,62,80,0.08)', display: 'block', margin: '0 auto' }} />
          <div style={{ display: 'flex', justifyContent: 'center', gap: 14, marginTop: 12, flexWrap: 'wrap' }}>
            {carouselImages.map(img => (
              <img
                key={img}
                src={img}
                alt="Thumbnail"
                style={{ width: 56, height: 56, objectFit: 'contain', borderRadius: 10, border: mainImage === img ? '2px solid #4A6FA5' : '2px solid #E9ECEF', cursor: 'pointer', background: '#fff', boxShadow: mainImage === img ? '0 2px 8px rgba(44,62,80,0.12)' : 'none' }}
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>
        </div>
        <ProductImage src="/product-image.png" alt="Derma Renew Complex" style={{ display: 'none' }} />
        <ProductTitle>Derma Renew Complex</ProductTitle>
        <Price>39€ <span style={{ fontSize: '1rem', color: '#6C757D', fontWeight: 400 }}>/ Monat</span> <span style={{ fontSize: '0.75rem', color: '#6C757D', marginLeft: 4 }}>inkl. MwSt.</span></Price>
        <PriceSub>Jederzeit kündbar</PriceSub>
        <BonusStack>
          <BonusTitle>Gratis Bonis</BonusTitle>
          <BonusList>
            <BonusItem>E-Book "Anti-Aging Blaupause"</BonusItem>
            <BonusItem>PDF Anti-Aging Checkliste</BonusItem>
            <BonusItem>Gratis Versand</BonusItem>
          </BonusList>
        </BonusStack>
        <div style={{ color: '#28A745', fontWeight: 600, marginBottom: 2, textAlign: 'center', fontSize: '1.02rem' }}>
          Auf Lager – in ca. 2-5 Tagen bei Ihnen
        </div>
        <CTAButton
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => window.location.href = 'https://dermapuris.de/step/kasse-derma-renew-komplex-1-4/'}
        >
          Jetzt bestellen
        </CTAButton>
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <img src="/payment-logos.png" alt="Zahlungsarten" style={{ maxWidth: 320, width: '100%', height: 'auto', margin: '0 auto' }} />
        </div>
      </ProductBox>
      <GuaranteeBanner>
        90 Tage Geld-zurück-Garantie – Testen Sie risikofrei!
      </GuaranteeBanner>
      <FAQSection>
        <FAQTitle>Häufig gestellte Fragen</FAQTitle>
        {faqs.map((faq, idx) => (
          <AccordionItem key={idx}>
            <AccordionHeader onClick={() => setOpenIdx(openIdx === idx ? null : idx)}>
              {faq.q}
              {openIdx === idx ? <FaChevronUp size={16} /> : <FaChevronDown size={16} />}
            </AccordionHeader>
            {openIdx === idx && (
              <AccordionContent>
                {faq.a}
              </AccordionContent>
            )}
          </AccordionItem>
        ))}
      </FAQSection>
    </Container>
  );
};

export default OfferScreen; 